import { render, staticRenderFns } from "./orderRepair.vue?vue&type=template&id=c980e8e0&scoped=true"
import script from "./orderRepair.vue?vue&type=script&lang=js"
export * from "./orderRepair.vue?vue&type=script&lang=js"
import style0 from "./orderRepair.vue?vue&type=style&index=0&id=c980e8e0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c980e8e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c980e8e0')) {
      api.createRecord('c980e8e0', component.options)
    } else {
      api.reload('c980e8e0', component.options)
    }
    module.hot.accept("./orderRepair.vue?vue&type=template&id=c980e8e0&scoped=true", function () {
      api.rerender('c980e8e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderRepair.vue"
export default component.exports